export default __webpack_public_path__ + "static/desktop-screen-41de9bb70c3bf2d70a6c63644481cc7c.png";